import * as React from 'react';
import {Modal} from "../../Modal";
import Button from "../../Button";
import './CreateEditComplimentaryLogoModal.css';
import { ILogo } from '../../../infrastructure/interfaces'
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import { contentImagesRelativePath } from '../../../constants';

export interface CreateEditComplimentaryLogoProps {
    show: boolean;
    onClose: any;
    logo?: ILogo;
    updateComplimentaryLogo(logoID: number, complimentaryLogoName: string, formData?: FormData): void;
    createComplimentaryLogo(complimentaryLogoName: string, formData: FormData): void;
}

export interface CreateEditComplimentaryLogoState {
    //Form State
    formData?: FormData;
    logoName: string;
    hasRequiredFields: boolean;
}

export default class CreateEditComplimentaryLogoModal extends React.Component<CreateEditComplimentaryLogoProps, CreateEditComplimentaryLogoState> {

    constructor(props: any) {
        super(props);

        this.state = {
            formData: undefined,
            logoName: (props.logo) ? props.logo.title : '',
            hasRequiredFields: false,
        };
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps: any) {
        var newLogoName = (nextProps.logo) ? nextProps.logo.title : '';
        this.setState({
            logoName: newLogoName,
            hasRequiredFields: newLogoName.length > 0
        });
      }

    updateComplimentaryLogo = () => {

        if (this.props.logo && this.props.logo.id) {
            if (this.props.updateComplimentaryLogo) {
                this.props.updateComplimentaryLogo(this.props.logo.id,
                                                   this.state.logoName,
                                                   this.state.formData);
            }
        } else {
            if (!this.state.formData) {
                return;
            }
            if (this.props.createComplimentaryLogo) {
                this.props.createComplimentaryLogo(this.state.logoName, this.state.formData);
            }
        }
    }

    handleChangeComplimentaryLogo(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {

            for (var key in selectorFiles) {
                var formData = new FormData();
                formData.set(ImageFileTypes.COMPLIMENTARY_LOGO, selectorFiles[key]);
                this.setState({formData},
                    () => this.hasValidFields());
                break;
            }
        }
    }

    onSave() {
 
        this.updateComplimentaryLogo();
        this.props.onClose(); 
    }

    handleInputGroupChange(newLogoName: string) {
        this.setState({
            logoName: newLogoName
        }, () => this.hasValidFields());
    }

    hasValidFields() {
        const hasValidText = (this.state.logoName.length > 1);
        const hasValidImages = (this.props.logo)
            ? true
            : (
                (this.state.formData != undefined)
                && (this.state.formData.get(ImageFileTypes.COMPLIMENTARY_LOGO) != null)
              )
        this.setState({ hasRequiredFields: (hasValidText && hasValidImages) });
    }

    closeModal() {
        this.setState({
            logoName: '',
        });
        this.props.onClose();
    }

    render() {
        return (
            <Modal show={this.props.show}
                   onClose={() => {this.closeModal();}}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            {this.props.logo ? this.props.logo.title : 'Upload Complimentary Logo'}
                        </h5>
                        (SVG)
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>                        
                </Modal.Header>
                <Modal.Body>
                    <div className="complimentaryLogoContainer">
                        <div className="complimentaryLogoInputContainer">
                            <div>
                                <b>Logo Name:  </b>
                                <input
                                    placeholder="Logo Name"
                                    maxLength={100}
                                    value={this.state.logoName}
                                    onChange={e => {
                                        this.handleInputGroupChange(e.target.value);
                                    } }/>
                            </div>
                        </div>

                        <div className="complimentaryLogoInputContainer">
                            <label>
                                <b>Image</b>
                            </label>
                            {
                                (this.props.logo)
                                    ? <div className="complimentaryLogoImageContainer"><img className="editImageModalImage" src={contentImagesRelativePath + this.props.logo.image} /></div>
                                    : <div></div>
                            }
                            <input type="file" className="filepond" onChange={(e) => this.handleChangeComplimentaryLogo(e.target.files)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={!this.state.hasRequiredFields}
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/CreateEditComplimentaryLogoModal/CreateEditComplimentaryLogoModal.tsx